




import {Vue, Component} from 'vue-property-decorator'

import LoginForm from '@/components/LoginForm.vue'

@Component({
  components: {
    LoginForm
  }
})
export default class AuthView extends Vue {

}
